module.exports = __webpack_public_path__ + "img/mobile-bars.b10c62e1.svg";